import React from 'react';

import { DAY_OF_WEEK } from 'app/typings/core/common/enum/dayOfWeek';
import { capitalizeFirstLetter } from 'app/utils/string';

import { ConstantValueInput } from '../../../../Common/ConstantValueInput/ConstantValueInput';
import { DailyConfigRow } from '../../../../Common/DailyConfigRow';

export const MaxBookingDailyRows: React.FC = () => {
  return (
    <>
      {Object.values(DAY_OF_WEEK).map((day) => (
        <DailyConfigRow
          key={day}
          day={day}
          basePath={[]}
          hasDisabledText={false}
          fieldNames={{ isToggled: 'isToggled', value: 'maxBooking' }}
        >
          {({ paths, day: renderDay }) => (
            <ConstantValueInput
              name={paths.value}
              label="Max"
              suffix={`bookings every ${capitalizeFirstLetter(renderDay)}`}
            />
          )}
        </DailyConfigRow>
      ))}
    </>
  );
};
